module.exports = __webpack_public_path__ + "static/img/banner_joinus.822848e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/english/banner_joinus.png
// module id = YxLe
// module chunks = 15